var StandardIcon = require("components/utility/icons/StandardIcon");

require("utility/brave_toolbar.scss");

class BraveToolbar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	render() {
		if (this.props.itemCount != undefined) {

			if (this.props.iconImage != undefined) {
				var icon = (
					<img className="iconImage" src={this.props.iconImage} alt="" />
				);
			} else if (this.props.icon && this.props.iconType) {
				var icon = (
					<StandardIcon icon={this.props.icon} type={this.props.iconType}
						className="iconImage" />
				);
			}
			if (icon && this.props.itemCount > 1) {
				var plural = (
					<span className="pluralSpan">s</span>
				);
			}
			if (this.props.itemCount > 0) {
				var clearAllLink = (
					<a href="#" className="clearAll" onClick={this.props.onClear}>Clear All</a>
				)
			}
			var selectedItems = (
				<div className="selectedItems">
					<div className="selectedTotal">
						<span className="itemCount">{this.props.itemCount}</span>
						{icon}{plural} selected
					</div>
					{clearAllLink}
				</div>
			);
		}

		return (
			<div className="braveToolbar initalHiddenPosition" ref="toolbar">
				<div className="container">
					<div className="col-sm-12 clearfix">
						{ selectedItems }
						<div className="actions">
							{ this.props.children }
						</div>
					</div>
				</div>
			</div>
		)
	}

	checkPositioning() {
		if ($(".siteFooter").length > 0) {
			var footerOffset = $(".siteFooter").offset().top;
			var winHeight = $(window).height();
			var scrollTop = $(window).scrollTop();

			if (scrollTop + winHeight > footerOffset) {
				$(this.refs.toolbar).addClass("atBottom");

				var isMobile = window.matchMedia("only screen and (max-width: 45rem)").matches;
				var top = isMobile ? footerOffset - scrollTop - ($(window).height() * .1) : footerOffset - scrollTop - 80;

				$(this.refs.toolbar).css("top", top + "px");

			} else {
				$(this.refs.toolbar).attr("style", "");
					$(this.refs.toolbar).attr("style", "").removeClass("atBottom");
			}
			
		}
	}

	componentDidUpdate() {
		this.checkPositioning();
	}

	componentDidMount() {
		$(window).scroll(this.checkPositioning);
		$(document.body).on("document_height_adjustment", this.checkPositioning);
		this.onElementHeightChange(document, this.checkPositioning);

		setTimeout(() => {
			$(this.refs.toolbar).removeClass("initalHiddenPosition");
			this.checkPositioning();
		}, 2000);
	}

	onElementHeightChange(elm, callback) {
		var lastHeight = $(elm).height();
		var newHeight;
		(function run() {
			if ($(elm).length == 0) { return; }

			newHeight = $(elm).height();
			if (lastHeight != newHeight) {
				callback();
			}
		
			lastHeight = newHeight;

			if (elm.onElementHeightChangeTimer) {
				clearTimeout(elm.onElementHeightChangeTimer);
			}

			elm.onElementHeightChangeTimer = setTimeout(run, 10);
		})();
	}
};

BraveToolbar.propTypes = StrictPropTypes({
	children: PropTypes.object,
	icon: PropTypes.string,
	iconType: PropTypes.string,
	itemCount: PropTypes.number,
	onClear: PropTypes.func
});

module.exports = BraveToolbar;



// WEBPACK FOOTER //
// ./modules/components/utility/BraveToolbar.js